import { Skeleton } from '@shared/components/shadcn';
import type { ReactNode } from 'react';
import {
  LIVE_DRAW_CARD_BOARD_CLASSES,
  LIVE_DRAW_CARD_CLASSES,
  LIVE_DRAW_CARD_HEADER_CLASSES,
  LIVE_DRAW_CARD_HEADER_INNER_CLASSES,
  LIVE_DRAW_CARD_TITLE_CLASSES,
} from '../components/LiveDrawPanel/liveDrawClasses';

/** Placeholder fill for every live-draw skeleton: a tint of the theme foreground, so it reads in both themes. */
const LIVE_DRAW_SKELETON_FILL = 'bg-foreground/10';

type LiveDrawCardSkeletonProps = {
  /** What the loaded card shows under its header: the board or the waiting-stage promotion. */
  children: ReactNode;
  'data-testid'?: string;
};

/**
 * The chrome of `LiveDrawGameCard` — the dated title line and the sound toggle over the board —
 * with the board left to the caller, which is the only part that differs between stages.
 */
function LiveDrawCardSkeleton({ children, 'data-testid': testId }: LiveDrawCardSkeletonProps) {
  return (
    <div data-testid={testId} className={LIVE_DRAW_CARD_CLASSES}>
      <div className={LIVE_DRAW_CARD_HEADER_CLASSES}>
        <div className={LIVE_DRAW_CARD_HEADER_INNER_CLASSES}>
          <Skeleton className={`${LIVE_DRAW_CARD_TITLE_CLASSES} ${LIVE_DRAW_SKELETON_FILL}`} />
          {/* The sound toggle is an `icon-m` button. */}
          <Skeleton className={`size-10 shrink-0 rounded-full ${LIVE_DRAW_SKELETON_FILL}`} />
        </div>
      </div>
      <div className={LIVE_DRAW_CARD_BOARD_CLASSES}>{children}</div>
    </div>
  );
}

export { LIVE_DRAW_SKELETON_FILL, LiveDrawCardSkeleton, type LiveDrawCardSkeletonProps };
